function hashStringToSeed(value) {
    let hash = 0;
    for(let i = 0; i < value.length; i++){
        hash = (hash << 5) - hash + value.charCodeAt(i);
        hash |= 0;
    }
    return hash >>> 0;
}
function seededShuffle(values, sessionId) {
    let seed = hashStringToSeed(sessionId);
    const random = ()=>{
        seed |= 0;
        seed = seed + 0x6d2b79f5 | 0;
        let t = Math.imul(seed ^ seed >>> 15, 1 | seed);
        t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t;
        return ((t ^ t >>> 14) >>> 0) / 4294967296;
    };
    const result = [
        ...values
    ];
    for(let i = result.length - 1; i > 0; i--){
        const j = Math.floor(random() * (i + 1));
        [result[i], result[j]] = [
            result[j],
            result[i]
        ];
    }
    return result;
}
export { seededShuffle };
